 const thoughtInspo = [
    {
        id: 1,
        message: 'Thought inspiration'
    },
    {
        id: 2,
        message: "It's fried day"
    },
    {
        id: 3,
        message: "Be wine today"
    },
    {
        id: 4,
        message: "CSS is so sweet"
    },
    {
        id: 5,
        message: "Enjoy the little things"
    }

 ]

 export default thoughtInspo;